

const awsConfig = {
      Auth: {
        Cognito: {
          userPoolId: process.env.REACT_APP_AWC_COGNITO_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID,
          identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
          loginWith: {
            email: true,
            oauth: {
              domain: [process.env.REACT_APP_OAUTH_DOMAIN], // e.g., 'myapp.auth.us-west-2.amazoncognito.com'
              scopes: ['openid','profile','email', 'aws.cognito.signin.user.admin'], // Scopes required by your app
              redirectSignIn: [
                'http://localhost:3000/client/cases' ,  'https://www.quickcasereview.com/client/cases'], // Must match callback URL(s) in Cognito
              redirectSignOut: ['http://localhost:3000',  'https://www.quickcasereview.com'], // Must match sign out URL(s) in Cognito
              responseType: 'code', 
            }
          },
          signUpVerificationMethod: "code",
          userAttributes: {
            email: {
              required: true,
            }
          },
          allowGuestAccess: true,
          passwordFormat: {
            minLength: 8,
            requireLowercase: true,
            requireUppercase: true,
            requireNumbers: true,
            requireSpecialCharacters: true,
          },
        },
      },
}


export default awsConfig;